import moment from 'moment';
import React from 'react';

import MobileHomeWeather from '../../../../pages/_Mobile/components/MobileHomeWeather';
import styles from './index.module.scss';

type StandbyScreenProps = {
  displayTime: Date;
  screenWakeUp: () => void;
};

const StandbyScreen = ({ displayTime, screenWakeUp }: StandbyScreenProps) => {
  return (
    <div className={styles.standbyScreen} onClick={screenWakeUp}>
      <div className={styles.simpleInfoContainer}>
        <p>{moment(displayTime).locale('zh-tw').format('MM/DD dddd')}</p>
        <p className={styles.timeText}>
          {moment(displayTime).format('HH:mm')}
          <span>{moment(displayTime).locale('en').format('A')}</span>
        </p>
        <div className={styles.weatherInfoContainer}>
          <MobileHomeWeather />
        </div>
      </div>
    </div>
  );
};

export default StandbyScreen;
